module.exports = __webpack_public_path__ + "img/thanks_icon.3457f7d1.svg";